import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonInputField } from './InputField.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonInputField({ prefix }));
}
